import { render, staticRenderFns } from "./asq.vue?vue&type=template&id=47a10aee&scoped=true"
import script from "./asq.vue?vue&type=script&lang=js"
export * from "./asq.vue?vue&type=script&lang=js"
import style0 from "./asq.vue?vue&type=style&index=0&id=47a10aee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a10aee",
  null
  
)

export default component.exports